module.exports = __webpack_public_path__ + "static/img/7.6c62fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/7.png
// module id = 7SqP
// module chunks = 0